import { 
    getAllServicesIaGlobalConfigService, 
    getServicesIaGlobalConfigByIdService, 
    createServicesIaGlobalConfigService, 
    updateServicesIaGlobalConfigService, 
    deleteServicesIaGlobalConfigService, 
    restoreServicesIaGlobalConfigService,
    getAppsToDropdownService
} from '../../services/servicesIaGlobalConfig.service';
import { 
    setGlobalConfigListRedux, 
    setGlobalConfigRedux,
    setApplicationsListSelectRedux
} from './servicesIaGlobalConfigSlice';
import { QueryPagination } from '../../commons/interfaces';

export const getAllGlobalConfigStore = (query?: QueryPagination) => {
    return async (dispatch: any) => {
        try {
            const response = await getAllServicesIaGlobalConfigService(query);
            if (response.ok) {
                dispatch(setGlobalConfigListRedux(response.data.data)); // Using data directly since mappers are removed
            }
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}

export const getGlobalConfigByIdStore = (id: string) => {
    return async (dispatch: any) => {
        try {
            const response = await getServicesIaGlobalConfigByIdService(id);
            if (response.ok) {
                dispatch(setGlobalConfigRedux(response.data));
            }
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}

export const createGlobalConfigStore = (data: any) => {
    return async () => {
        try {
            const response = await createServicesIaGlobalConfigService(data);
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}

export const editGlobalConfigStore = (id: string, data: any) => {
    return async () => {
        try {
            const response = await updateServicesIaGlobalConfigService(id, data);
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}

export const deleteGlobalConfigStore = (id: string, query?: QueryPagination) => {
    return async (dispatch: any) => {
        try {
            const response = await deleteServicesIaGlobalConfigService(id, query);
            if (response.ok) {
                dispatch(getAllGlobalConfigStore(query));
            }
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}

export const restoreGlobalConfigStore = (id: string, query?: QueryPagination) => {
    return async (dispatch: any) => {
        try {
            const response = await restoreServicesIaGlobalConfigService(id, query);
            if (response.ok) {
                dispatch(getAllGlobalConfigStore(query));
            }
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}

export const getDataFormDropDownStore = () => {
    return async (dispatch: any) => {
        try {
            const response = await getAppsToDropdownService();
            if (response.ok) {
                dispatch(setApplicationsListSelectRedux(response.data));
            }
            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}
